/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Marketing/view.blocks to change it.
import CampaignChooser from './CampaignChooser/index'
import CardBase from 'DesignSystem/CardBase/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Info from 'DesignSystem/Info/index'
import LeadsConfigurationChooser from './LeadsConfigurationChooser/index'
import LocationChooser from './LocationChooser/index'
import RangeChooser from './RangeChooser/index'
import React from 'react'
import ReportTable from './ReportTable/index'
import ShowDismissed from './ShowDismissed/index'
import SubTitle from 'DesignSystem/SubTitle/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Marketing({
  children,
  viewPath = "/App/Account/Content/Marketing"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Marketing.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-1ghU7h': isBefore ? 0 : 1,'--ty-2-1ghU7h': isBefore ? "-8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Marketing.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Marketing.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginTop={0}
 text="Filter Campaigns"
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={12}
 whiteSpace="wrap"
 hyphens="none"
 fontSize={12}
 lineHeight="16px"
 text="Select locations and campaigns to filter the Marketing data."
/>
</div>
<CardBase
  viewPath={`${viewPath}/CardBase`}
 backgroundColor="#fff"
 shadowColor="rgba(0, 0, 0, 0)"
 flexDirection="row"
 paddingBottom={12}
 zIndex={1000}
 overflowY="visible"
>
{childProps => (
<div
  data-testid="Marketing.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Marketing.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<LeadsConfigurationChooser
  viewPath={`${viewPath}/LeadsConfigurationChooser`}
/>
<CampaignChooser
  viewPath={`${viewPath}/CampaignChooser`}
/>
<ShowDismissed
  viewPath={`${viewPath}/ShowDismissed`}
/>
</div>
<RangeChooser
  viewPath={`${viewPath}/RangeChooser`}
/>
</div>
)}
</CardBase>
</div>
<ReportTable
  viewPath={`${viewPath}/ReportTable`}
/>
</div>
{children}
</React.Fragment>)
}